import { APPROVAL_STATUS, TASK_KIND, type TaskInstanceWithSubmission } from '@fdh/shared';

/** Query flag: helper Home Stock detail overview (comments, task summary) without wizard redirect. */
export const HELPER_HOME_STOCK_OVERVIEW_QUERY = 'helperHomeStockOverview';

export const buildHelperHomeStockOverviewPath = (taskInstanceId: string): string =>
  `/task-instances/${encodeURIComponent(taskInstanceId)}?${HELPER_HOME_STOCK_OVERVIEW_QUERY}=1`;

export const isHelperHomeStockOverviewSearch = (search: string): boolean => {
  const normalized = search.startsWith('?') ? search : `?${search}`;
  return new URLSearchParams(normalized).get(HELPER_HOME_STOCK_OVERVIEW_QUERY) === '1';
};

export const isTaskInstanceHelperHomeStockOverviewEligible = (
  taskInstance: TaskInstanceWithSubmission,
): boolean => {
  if (taskInstance.task.taskKind !== TASK_KIND.INVENTORY) {
    return false;
  }
  const submittedAt =
    taskInstance.submission?.submittedAt?.trim() ?? taskInstance.submittedAt?.trim() ?? '';
  if (taskInstance.status === APPROVAL_STATUS.NEEDS_UPDATE) {
    return true;
  }
  if (taskInstance.status === APPROVAL_STATUS.PENDING && submittedAt === '') {
    return true;
  }
  return false;
};

export type HelperHomeStockOverviewLocationState = {
  helperHomeStockOverview?: boolean;
  from?: string;
};

export type InventoryWizardStartLocationState = {
  startSubmitWizard?: boolean;
  from?: string;
};
